import api from 'services/api'

export const PesquisaPorPlaca = async (Placa: string) =>
  api.get('Veiculo/pesquisa-por-placa', {
    params: {
      placa: Placa
    }
  })
